import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { getSearchPage } from "../../utils/searchMetadata";
import { MarketingBody, ProductSearchIntro } from "./PublicContent";

const ProductPage = lazy(() => import("../../pages/Products"));

export default function SearchableProductPage() {
  const { pathname } = useLocation();
  const page = getSearchPage(pathname);
  return (
    <>
      {page ? <ProductSearchIntro page={page} /> : null}
      <Suspense fallback={<p className="search-container" role="status">Laster produktdesigneren …</p>}>
        <ProductPage />
      </Suspense>
      {page ? <MarketingBody page={page} /> : null}
    </>
  );
}
